import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import R from 'ramda';

import Box from 'react-bulma-companion/lib/Box';
import Section from 'react-bulma-companion/lib/Section';
import Container from 'react-bulma-companion/lib/Container';
import Title from 'react-bulma-companion/lib/Title';

export default function ThankYou() {
  const dispatch = useDispatch();
  const { user } = useSelector(R.pick(['user']));

  var firstName = user.firstName;
  var lastName = user.lastName;

  useEffect(() => {
    if (R.isEmpty(user)) {
      dispatch(push('/evaluator'));
    }
  }, []);

  return (
    <div className="progress-page page" style={{paddingTop: "25px"}}>
      <Section>
        <Container>
          <Box className="survey-box progress-box">
            <div className="head">
              <Title>Thank You{firstName != '' ? `, ${firstName}` : ''}!</Title>
              <h3 className='subtitle'>This is how how the process will go from here:</h3>
            </div>

            <ol className="progress-steps">
              <li className="complete">
                <h2>Case Evaluation</h2>
                <p>You have completed a legal case evaluation using our custom AI which catered the evaluation to the facts of your particular case.</p>
              </li>
              <li className="complete">
                <h2>Retainer</h2>
                <p>You have signed a retainer agreement with Abramson Labor Group which specifies the scope and terms of the legal representation Abramson Labor Group will provide you.</p>
              </li>
              <li className="complete">
                <h2>Intake</h2>
                <p>Within the next business day, a designated intake paralegal will be reaching out to you by phone and email to complete a comprehensive intake. This intake takes about 45 minutes and will give us the opportunity to gather the key information we will need to advocate on your behalf.</p>
              </li>
              <li className="active">
                <h2>Notice of Claims</h2>
                <p>We'll send an official correspondence to your employer from our firm to put them on notice of your claims. The letter will highlight possible legal claims and seek to gather key information from your employer regarding your claims.</p>
              </li>
              <li>
                <h2>Your In-Depth Attorney Consultation</h2>
                <p>After we send your notice of claims - but before we send a demand letter - to your employer, you will be assigned a dedicated attorney who will reach out to you to conduct an in depth consultation to determine the best possible course of action in your case.</p>
              </li>
              <li>
                <h2>Case Development</h2>
                <p>Based upon the information you've shared with our firm, the available evidence, your attorney consultation, and the defendant's posture towards resolution our firm will develop your case in line with the best course of action for your situation.</p>
              </li>
              <li>
                <h2>Resolution</h2>
                <p>Our goal is to achieve the best possible outcome for your case. Depending on the available evidence and egregiousness of your employer's conduct as well as your employer's willingness to acknowledge wrongdoing, a range of outcomes may occur. Possible outcomes include early resolution by settlement, pairing your case with the best possible attorney for litigation, or advising you that your case is best resolved through other means. Our ultimate goal is to help you obtain justice!</p>
              </li>
            </ol>
          </Box>
        </Container>
      </Section>
    </div>
  );
}
